import React, { useContext } from "react";
import styled from "styled-components";
import globalContext from "../../Hooks/globalContext";
import languagePack from "../../Utils/language";

const Header = styled.div`
  height: 90px;
  padding: 0px 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.div`
  font-size: 24px;
  color: ${(props) => props.theme.black};
`;

const SubTitle = styled.div`
  margin-top: 10px;
  font-size: 16px;
  color: ${(props) => props.theme.darkGrey};
`;

const titleFactory = (page, language) => {
  switch (page) {
    case "userList":
      return {
        title: languagePack("유저 목록", language.state),
        subTitle: languagePack("유저를 관리합니다.", language.state),
      };
    case "lockupList":
      return {
        title: languagePack("락업 로그", language.state),
        subTitle: languagePack("락업 관련 로그를 조회합니다.", language.state),
      };
    case "stakingList":
      return {
        title: languagePack("스테이킹 로그", language.state),
        subTitle: languagePack("스테이킹 관련 로그를 조회합니다.", language.state),
      };
    case "noticeList":
      return {
        title: "공지사항 관리",
        subTitle: "공지사항 게시물을 관리합니다.",
      };
    case "noticeWrite":
      return {
        title: "공지사항 관리",
        subTitle: "공지사항 게시물을 관리합니다.",
      };
    case "noticeUpdate":
      return {
        title: "공지사항 관리",
        subTitle: "공지사항 게시물을 관리합니다.",
      };
    case "config":
      return {
        title: languagePack("설정", language.state),
        subTitle: languagePack("ASK 월렛 기본 설정을 조정합니다.", language.state),
      };
  }
};

const AdminHeader = ({ page }) => {
  const { language } = useContext(globalContext);
  const info = titleFactory(page, language);

  return (
    <Header>
      <Title>{info.title}</Title>
      <SubTitle>{info.subTitle}</SubTitle>
    </Header>
  );
};

export default AdminHeader;
